// Pre-auths settings: how long an approved pre-auth's treatment can wait before ELVA reminds
// you (D228). In-memory mock; nothing reads it yet, because Approved has no "treatment isn't
// done" reminder in the mock.
import { useSyncExternalStore } from 'react';

export const DEFAULT_REMINDER_MONTHS = 6;
export const MIN_REMINDER_MONTHS = 1;
export const MAX_REMINDER_MONTHS = 24;

let months = DEFAULT_REMINDER_MONTHS;
const listeners = new Set<() => void>();

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function getReminderMonths(): number {
  return months;
}

/** Save the value; it applies from today on. */
export function setReminderMonths(next: number): void {
  const clamped = Math.max(MIN_REMINDER_MONTHS, Math.min(MAX_REMINDER_MONTHS, Math.round(next)));
  if (clamped === months) return;
  months = clamped;
  for (const l of listeners) l();
}

export function useReminderMonths(): number {
  return useSyncExternalStore(subscribe, getReminderMonths, getReminderMonths);
}
